export const entryStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  padding: '12px 16px',
  '&:not(:last-of-type)': {
    borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  },
};

export const entryBodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  flex: 1,
  minWidth: 0,
};

export const entryHeaderStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  gap: '4px 8px',
};
